import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { EmployeeSideBar } from "./EmployeeSideBar";

const Submenu = () => {
  const userPermissions = useRecoilValue(permissionsSelector);
  const { pathname } = useLocation();
  const [hover, setHover] = useState();

  const index1 = EmployeeSideBar.findIndex((item) => pathname === item.to);

  const baseClass = "flex items-center sidebar-text-size p-2";

  const activeClass = "bg-white rounded-l-lg text-secondary font-medium";

  const getIsRounded = (index) =>
    hover === index ||
    index === hover - 1 ||
    index === 11 ||
    index1 === index + 1;

  const getInactiveClass = (isRounded) => `
    text-white bg-quinary hover:bg-secondary
    ${
      isRounded ? "rounded-l-lg" : "border-b border-septenary border-opacity-25"
    }
  `;

  return (
    <div className="pl-4 py-4 rounded-l-lg bg-quinary">
      {EmployeeSideBar.map((item, index) => {
        if (!userPermissions.includes(item.permission)) return null;

        const isActive = item.to === pathname;
        const isRounded = getIsRounded(index);

        const className = `${baseClass} ${
          isActive ? activeClass : getInactiveClass(isRounded)
        }`;

        return (
          <Link
            key={item.to}
            to={item.to}
            onMouseEnter={() => setHover(index)}
            onMouseLeave={() => setHover(undefined)}
            className={className}
          >
            {item.title}
          </Link>
        );
      })}
    </div>
  );
};

export default Submenu;
